import React from "react";

export const STATUS_STYLES = {
  Active: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  Inactive: "bg-zinc-500/15 text-zinc-300 border-zinc-500/30",
  "Needs Attention": "bg-amber-500/15 text-amber-300 border-amber-500/30",
  Archived: "bg-zinc-700/20 text-zinc-500 border-zinc-600/30",
  Forming: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  "Not Started": "bg-zinc-500/15 text-zinc-300 border-zinc-500/30",
  "In Progress": "bg-sky-500/15 text-sky-300 border-sky-500/30",
  Waiting: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  Completed: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  Cancelled: "bg-red-500/15 text-red-300 border-red-500/30",
  High: "bg-red-500/15 text-red-300 border-red-500/30",
  Medium: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  Low: "bg-zinc-500/15 text-zinc-300 border-zinc-500/30",
};

export const StatusBadge = ({ status }) => (
  <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${STATUS_STYLES[status] || "bg-zinc-500/15 text-zinc-300 border-zinc-500/30"}`}>
    {status}
  </span>
);

export const StatCard = ({ label, value, sub, testid, onClick, accent }) => (
  <button
    onClick={onClick}
    disabled={!onClick}
    data-testid={testid}
    className={`text-left rounded-xl border border-white/10 bg-zinc-900/50 p-5 w-full ${onClick ? "hover:border-primary/40 transition-colors cursor-pointer" : "cursor-default"}`}
  >
    <div className="text-xs uppercase tracking-wider text-muted-foreground">{label}</div>
    <div className={`font-display text-3xl tracking-tighter mt-2 ${accent ? "text-primary" : "text-foreground"}`}>{value}</div>
    {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
  </button>
);

export const SectionHeader = ({ title, subtitle, action }) => (
  <div className="flex items-end justify-between gap-4 mb-6">
    <div>
      <h1 className="font-display text-2xl sm:text-3xl tracking-tighter">{title}</h1>
      {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const EmptyState = ({ icon: Icon, title, hint }) => (
  <div className="rounded-xl border border-dashed border-white/10 bg-zinc-900/30 p-12 text-center">
    {Icon && <Icon size={40} weight="duotone" className="mx-auto text-muted-foreground mb-4" />}
    <div className="font-medium">{title}</div>
    {hint && <div className="text-sm text-muted-foreground mt-1">{hint}</div>}
  </div>
);

export const fmtDate = (s) => {
  if (!s) return "—";
  try {
    return new Date(s.length <= 10 ? s + "T00:00:00" : s).toLocaleDateString(undefined, {
      year: "numeric", month: "short", day: "numeric",
    });
  } catch {
    return s;
  }
};
